import { useCallback } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';

import { TrendingSectionSkeleton } from '../skeletons';

export const LazyTrendingSection: React.FC = () => {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "pages/homepage-trendingSection" */ '../TrendingSection')).TrendingSection,
		[],
	);

	return (
		<ClientRender placeholder={<TrendingSectionSkeleton />}>
			<ScrollableComponent topOffset={200} immediateForBots fallback={<TrendingSectionSkeleton />}>
				<LazyComponent loadComponent={loadComponent} fallback={<TrendingSectionSkeleton />} />
			</ScrollableComponent>
		</ClientRender>
	);
};
